import React from "react";
import Cardforwork from "./Cardforwork";

export default function Recentwork() {
  return (
    <div className="container-fluid main">
      {/* <h2 className="rc">~/Recent Projects</h2> */}
      <h5 className="highlightedtext">Highlighted Projects</h5>
      <h3 className="rc">What I've been working on</h3>
      <div className="row">
        <div className="col-md-4 col-sm-4">
          <Cardforwork
            title="ToolsGarage"
            tech="ReactJS, Bootstrap, APIs"
            about=" Hub of Web Utility applications like Image, Pdf Compression and more ."
            // imgsrc={require("../assets/P10.png")}
            weburl="https://toolsgarage.vercel.app/"
          />
        </div>

        <div className="col-md-4 col-sm-4">
          <Cardforwork
            title="Fitness Junction"
            tech="ReactJS, Bootstrap, Firebase"
            about="Comprehensive library of exercises catering to all fitness enthusiasts."
            //imgsrc={require("../assets/P8.png")}
            weburl="https://fitnessjunction.netlify.app/"
          />
        </div>

        <div className="col-sm-4">
          <Cardforwork
            title="The DailyDose"
            tech="ReactJS, News API"
            about="News app, delivering the latest headlines from around the world at your fingertips."
            //imgsrc={require("../assets/P4.png")}
            weburl="https://thedailydose.netlify.app/"
          />
        </div>

        <div className="col-md-4 col-sm-4">
          <Cardforwork
            title="Weather App"
            tech="ReactJS, Open-Weather API"
            about="Stay ahead of the weather with this visually appealing weather app !"
            // imgsrc={require("../assets/P5.png")}
            weburl="https://weathervibe.netlify.app/"
          />
        </div>

        <div className="col-md-4 col-sm-4">
          <Cardforwork
            title="Trippy Travels"
            tech="ReactJS, User-Inerface"
            about="Travel website, showcasing various destinations and travel packages."
            // imgsrc={require("../assets/P7 travel.png")}
            weburl="https://trippytravels.netlify.app/"
          />
        </div>

        <div className="col-md-4 col-sm-4">
          <Cardforwork
            title="MoviesHub"
            tech="ReactJS, MoviesAPI, Context API"
            about="Movie database, search and explore your favorite movies and TV shows."
            // imgsrc={require("../assets/P9.png")}
            weburl="https://movieshubtime.netlify.app/"
          />
        </div>

        <div className="col-md-4 col-sm-4">
          <Cardforwork
            title="Splitwise - Finance Manager"
            tech="ReactJS, Bootstrap, Javascript"
            about="Expense manager, split bills and keep track of your expenses with friends."
            // imgsrc={require("../assets/P10.png")}
            weburl="https://splitwisee.netlify.app/"
          />
        </div>
      </div>
    </div>
  );
}
